/**
 * Registre UNIQUE des routes servies hors de la session interne : pages
 * publiques, pages de compte à lien, portail client, espace sous-traitant et
 * console. `App.tsx` pose ces routes et `isExternalPath` décide du démarrage
 * de session à partir de la même liste : deux listes tenues à la main avaient
 * divergé (`/transfert-machine/` manquait au démarrage).
 */
import type { ReactNode } from 'react';
import { matchPath, Route } from 'react-router-dom';
import type { ExternalRoute } from './route-types.js';
import { publicRoutes } from '../features/public/routes.js';
import { authRoutes } from '../features/auth/routes.js';
import { portalRoutes } from '../features/portal/routes.js';
import { subcontractorRoutes } from '../features/subcontractor/routes.js';
import { superadminRoutes } from '../features/superadmin/routes.js';

export const EXTERNAL_ROUTES: readonly ExternalRoute[] = [
  ...publicRoutes,
  ...authRoutes,
  ...portalRoutes,
  ...subcontractorRoutes,
  ...superadminRoutes,
];

/**
 * Vrai si le chemin appartient à un espace externe (session propre). Même
 * correspondance que React Router : `/fournisseur` n'attrape pas
 * `/fournisseurs`, et `/portail/*` répond aussi sur `/portail`.
 */
export function isExternalPath(pathname: string): boolean {
  return EXTERNAL_ROUTES.some((route) => matchPath({ path: route.path, end: true }, pathname) !== null);
}

export function externalRouteElements(): ReactNode[] {
  return EXTERNAL_ROUTES.map((route) => <Route key={route.path} path={route.path} element={route.element} />);
}
